<template>
  <div class="pageContent indexUser">
    <div class="indexBannar"><Vswipe :banner="banner" /></div>
    <div class="pageFlex userInfo">
      <!-- · 升级会员可享受服务折扣 -->
      <div class="vipcard">
        <div class="vip-left">
          <div class="vip-card">
            <span class="vip-label">会员ID</span>
            <span class="vip-id">{{ userInfo.userNo || '0000000' }}</span>
          </div>
          <!-- <span class="verified-tag">
            <svg t="1782212343066" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8980" width="10" height="10">
              <path d="M511.974401 0c-282.75527 0-511.974401 229.219131-511.974401 511.974401 0 282.757318 229.219131 511.974401 511.974401 511.974401 282.757318 0 511.974401-229.217083 511.974401-511.974401C1023.948803 229.219131 794.729672 0 511.974401 0zM805.63063 379.174385 474.510162 710.296901c0 0-0.004096 0.004096-0.010239 0.010239-15.265029 15.269125-38.541433 17.652877-56.31104 7.157402-3.290971-1.945503-6.393536-4.333351-9.219635-7.157402-0.002048-0.004096-0.006144-0.006144-0.006144-0.006144l-190.642884-190.642884c-18.095223-18.095223-18.095223-47.4375 0-65.536819 18.095223-18.095223 47.4375-18.095223 65.532723 0l157.884714 157.884714 298.362298-298.362298c18.097271-18.095223 47.439548-18.095223 65.534771 0C823.725854 331.738933 823.725854 361.079162 805.63063 379.174385z" fill="#ffffff" p-id="8981"></path>
            </svg>
            <span style="margin-left: 2px">实名</span>
          </span> -->
        </div>
        <div class="vip-right">
          <div @click="customerService">
            <svg t="1782211903782" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7906" width="16" height="16"><path d="M362.403292 95.115814C163.141681 95.115814 0 230.56555 0 403.339212c0 99.329806 54.179894 181.201646 145.081717 244.411523l-36.119929 108.961787 126.419753-63.811875c45.149912 9.029982 81.87184 18.059965 127.021752 18.059965 11.437978 0 22.875955-0.601999 33.711934-1.203998-7.223986-24.079953-11.437978-49.363904-11.437978-75.851852 0-158.325691 136.051734-286.55144 308.223398-286.55144 12.039976 0 23.477954 0.601999 34.915932 2.407995C696.51264 203.475603 540.594944 95.115814 362.403292 95.115814zM240.79953 339.527337c-24.681952 0-44.547913-19.865961-44.547913-44.547913 0-24.681952 19.865961-44.547913 44.547913-44.547913s44.547913 19.865961 44.547913 44.547913C285.347443 319.661376 265.481481 339.527337 240.79953 339.527337zM495.445032 339.527337c-24.681952 0-44.547913-19.865961-44.547913-44.547913 0-24.681952 19.865961-44.547913 44.547913-44.547913s44.547913 19.865961 44.547913 44.547913C539.992945 319.661376 520.126984 339.527337 495.445032 339.527337zM1024 629.69077c0-145.081717-145.081717-263.073486-307.621399-263.073486-172.171664 0-308.223398 117.99177-308.223398 263.073486 0 145.081717 136.051734 263.073486 308.223398 263.073486 36.119929 0 72.239859-9.029982 108.961787-18.059965l99.329806 54.179894-27.089947-90.299824C969.820106 783.802469 1024 711.56261 1024 629.69077zM620.660788 583.938859c-19.865961 0-36.119929-16.253968-36.119929-36.119929s16.253968-36.119929 36.119929-36.119929 36.119929 16.253968 36.119929 36.119929S640.526749 583.938859 620.660788 583.938859zM817.514403 583.938859c-19.865961 0-36.119929-16.253968-36.119929-36.119929s16.253968-36.119929 36.119929-36.119929 36.119929 16.253968 36.119929 36.119929S837.982363 583.938859 817.514403 583.938859z" fill="#8a8a8a" p-id="7907"></path></svg>
            <span class="vip-link">联系客服</span>
          </div>
          <div @click="goHelp">
            <svg t="1782211830558" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5992" width="16" height="16"><path d="M512 64C264.64 64 64 264.64 64 512c0 247.424 200.64 448 448 448 247.488 0 448-200.576 448-448C960 264.64 759.488 64 512 64zM512 768c-26.432 0-48-21.504-48-48S485.568 672 512 672c26.624 0 48 21.504 48 48S538.624 768 512 768zM560 528C560 554.56 538.624 576 512 576 485.568 576 464 554.56 464 528l0-224C464 277.44 485.568 256 512 256c26.624 0 48 21.44 48 48L560 528z" fill="#8a8a8a" p-id="5993"></path></svg>
            <span class="vip-link">使用帮助</span>
          </div>
        </div>
      </div>

      <div class="vipbody" style="width:100%">
        <div class="flex">
          <div class="userImg">
            <img class="lgImg" :src="lgImg" />
          </div>
          <!-- <KImg class="pageIndexImgShadow" :src="userInfo.head_img_url"  v-else/> -->
          <div class="userMobile" @click="updateMobile">
            <div>已绑定手机号</div>
            <div style="font-size: 11px; color: #777777; font-weight: 800;">{{ userInfo.userPhone }}</div>
            <!-- <span>{{ userInfo.mobile_phone }}</span> -->
          </div>
        </div>
        <div class="pageFlexBetween">
          <div 
            @click="$push({ name: 'PointsAccounts' })"
            class="cardTag"
            style="background-color: rgba(129, 211, 248, 0.08); color: #02A7F0; border: 1px solid rgba(129, 211, 248, 0.15);"
          >
            <img :src="pointsImg" alt="" width="22px" height="22px" /> 
            <span>积分：</span>
            <span style="font-weight: 900; vertical-align: middle; font-size: 14px;">
              {{ totalPoints }}
            </span>
          </div>

          <div style="display: flex;">
            <div 
              @click="$push({ path: '/coupons' })"
              class="cardTag"
              style="margin-left: 10px; color:#D9001B;border: 1px solid rgba(236, 128, 141, 0.15);"
            >
              <span>卡券</span>
            </div>
  
            <div 
              v-if="waitPayOrdersCount > 0"
              @click="$push({ path: '/refunds' })"
              class="cardTag"
              style="margin-left: 10px; color:#D9001B;border: 1px solid rgba(236, 128, 141, 0.15);"
            >
              <span>权益回收</span>
            </div>
  
            <div 
              @click="$push({ path: '/orders?type=-1' })"
              class="cardTag"
              style="margin-left: 10px; color:#D9001B;border: 1px solid rgba(236, 128, 141, 0.15);"
            >
              <span>订单</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <van-button
        v-if="waitPayOrdersCount > 0"
        type="default"
        size="small"
        round
        @click="$push({ path: '/refunds' })"
        style="margin-right: 15px"
        >权益回收</van-button
      > -->
    </div>
    
    <div class="recommend" v-if="exchangeService.length > 0" style="background-color: #f53415;">
      <div class="gift" style="color:#fff">
        <img :src="giftImg" alt="" width="25px" height="25px" />
        <span >推荐权益</span>
        <span style="position: absolute; right: 10px;">超值精选、一键兑换</span>
      </div>
    </div>
    <ul class="pageFlexBetweenWrap serviceList"  v-show="exchangeService.length > 0">
      <li
        class="pageFlexColumn"
        v-for="(item, index) in exchangeService"
        :key="index"
        @click="next(item)"
      >
        <div class="pageFlexCenter icons" style="position: relative;" :class="item.ico_class">
          <div class="online-div">
            <van-image
              class="online-icon"
              style="width:60%"
              :src="require('@/assets/online/' + item.local_icon + '.png')"
            />
            <div class="online-mask" v-show="item.stockStatus == 0"></div>
            <div  
              v-if="item.stockStatus == 0" 
              class="bubble" style="top: 0px;right: -5px;"
            >缺货</div>
          </div>
        </div>
        <span class="pageSpanFont" style="margin: 15px 0">{{
          item.name
        }}</span>
      </li>
    </ul>

    <div class="recommend" v-if="changeService.length > 0" 
      style="background-color:rgba(99, 161, 3, 0.11); border: 1px solid rgba(99, 161, 3, 0.16)">
      <div class="gift" style="color:#08C662">
        <img :src="cardImg" alt="" width="25px" height="25px" />
        <span >权益券包</span>
        <span style="position: absolute; right: 10px;">红包权益、畅享福利</span>
      </div>
    </div>
    <ul class="pageFlexBetweenWrap serviceList" v-show="changeService.length > 0">
      <li
        class="pageFlexColumn"
        v-for="(item, index) in changeService"
        :key="index"
        @click="next(item)"
      >
        <div class="pageFlexCenter icons" style="position: relative;" :class="item.ico_class">
          <van-image
            class="online-icon"
            :src="require('@/assets/online/' + item.local_icon + '.png')"
          />
          <div v-if="item.stockStatus == 0" class="bubble">缺货</div>
        </div>
        <span class="pageSpanFont" style="margin: 5px 0px 0px 0px">{{
          item.name
        }}</span>
      </li>
    </ul>

    <div class="recommend" v-if="recoveryService.length > 0" 
      style="background-color:rgba(129, 211, 248, 0.11);border: 1px solid rgba(129, 211, 248, 0.41)">
      <div class="gift" style="color:#02A7F0">
        <img :src="transferImg" alt="" width="25px" height="25px" />
        <span >权益转让服务</span>
        <span style="position: absolute; right: 10px;">批量寄售、大额专区</span>
      </div>
    </div>
    <ul class="pageFlexBetweenWrap serviceList" v-show="recoveryService.length > 0">
      <li
        class="pageFlexColumn"
        v-for="(item, index) in recoveryService"
        :key="index"
        @click="next(item)"
      >
        <div class="pageFlexCenter icons" style="position: relative;" :class="item.ico_class">
          <van-image
            class="online-icon"
            :src="require('@/assets/online/' + item.local_icon + '.png')"
          />
          <div v-if="item.stockStatus == 0" class="bubble">缺货</div>
        </div>
        <span class="pageSpanFont" style="margin: 5px 0px 0px 0px">{{
          item.name
        }}</span>
      </li>
    </ul>

    <!-- 线下服务 -->
    <!-- markStar -->
    <div
      data-v-7013b2bb=""
      data-v-ae779e0c=""
      class="carService"
      v-if="
        service_list.findIndex((item) => item.label == 'offlineService') >= 0 ||
        service_list.findIndex((item) => item.label == 'examined')
      "
    >
      <div class="recommend" v-if="offlineList.length > 0" 
        style="background-color: rgba(245, 154, 35, 0.35); border: 1px solid rgba(245, 154, 35, 0.24)">
        <div class="gift" style="color:#F59A23">
          <img :src="carImg" alt="" width="25px" height="25px" />
          <span >车主服务</span>
          <span style="position: absolute; right: 10px;">车主专属、畅行无阻</span>
        </div>
      </div>
      <ul class="pageFlexBetweenWrap serviceList">
        <li
          class="pageFlexColumn"
          v-for="(item, index) in offlineList"
          :key="index"
          @click="offlineClickHandle(item)"
        >
          <div class="pageFlexCenter icons">
            <div class="offline-icon">
              <!-- <img :src="item.ico_name" class="van-image__img" /> -->
              <van-image
                :src="
                  item.ico_name
                    ? item.ico_name
                    : require('@/assets/offline/' + item.local_icon + '.png')
                "
              />
            </div>
          </div>
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vswipe from "./Vswipe.vue";
import { getBatchRecoveryUrl } from "api/onLine";
import { getCoupons, getPoiontsAccountByCurrentUserApi } from "api/user";
import { getWechatInfo } from "api/recycle"

export default {
  props: {
    notice: {
      type: String,
      default: () => "",
    },
    banner: {
      type: Array,
      default: () => [],
    },
    exchangeService: {
      type: Array,
      default: () => [],
    },
    changeService: {
      type: Array,
      default: () => [],
    },
    recoveryService: {
      type: Array,
      default: () => [],
    },
    onlinelist: {
      type: Array,
      default: () => [],
    },
    offlineList: {
      type: Array,
      default: () => [],
    },
    service_list: {
      type: Array,
      default: () => [],
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    healthService: {
      type: Array,
      default: () => [],
    },
    waitPayOrdersCount: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Vswipe,
  },
  data() {
    return {
      lgImg: require("assets/user_bg2.png"),
      Img_1: require("assets/h_msg.png"),
      Img_2: require("assets/h_doct.png"),
      Img_3: require("assets/h_host.png"),
      Img_4: require("assets/doct.jpg"),
      Img_5: require("assets/jidong.png"),
      Img_6: require("assets/shop.png"),
      Img_7: require("assets/anquanjiance.svg"),
      giftImg: require("assets/gift2.png"),
      cardImg: require("assets/cardIcon.png"),
      transferImg: require("assets/transferIcon.png"),
      carImg: require("assets/carIcon.png"),
      couponImg: require("assets/coupon.png"),
      pointsImg: require("assets/points.png"),
      hostname: "",
      show: false,
      onLineIconName: "",
      totalPoints: 0,
    };
  },
  created() {
    this.hostname = location.hostname;    
  },
  mounted() {
    this.fetchAccounts()
  },
  methods: {
    goHelp() {
      this.$push({ name: 'ServiceHelp' });
    },
    async fetchAccounts() {
      const res = await getPoiontsAccountByCurrentUserApi()
      let accounts = res.data ?? []
      let total = accounts.reduce((sum, a) => sum + a.balance, 0)
      this.totalPoints = Number(total.toFixed(2))
    },
    customerService() {
      this.$alert('如需客服服务支持，请在公众号聊天窗口发送消息即可。')
    },
    async updateMobile() {
      this.$push({
        path: "/updateMobile",
        query: { phone: this.userInfo.userPhone },
      });
    },
    showIcon(name) {
      if (this.hostname.indexOf("zyb.tongdaogu.cn") < 0) {
        return true;
      } else {
        if ((name != "油卡充值") & (name != "话费充值")) {
          return true;
        } else {
          return this.show;
        }
      }
    },
    async batchHandleNext(couponsId) {
      // getBatchRecoveryUrl(couponsId).then((res) => {
      //   if (res.status == 200) {
      //     if ((res.data != "") & (res.data != null)) {
      //       location.href = res.data;
      //     }
      //   } else {
      //     this.$error(res.message);
      //   }
      // });
      const res = await getWechatInfo(couponsId)
      if (res.status === 200) {
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.data.appid}&redirect_uri=${res.data.redirectUrl}&response_type=code&scope=snsapi_base&state=${res.data.state}#wechat_redirect`
        console.log(url)
        location.href = url 
      }
    },
    async next(item) {
      if(item.stockStatus == 0) return
      if(item.status == 0){
        this.$dialog({
          title: "提 示",
          message: "通道维护中...",
        }).then(() => {});
        return
      }
      let couponsList = []
      if(['weChatRedPacket', 'recovery', 'bankWithdraw','alipayWithdraw','weChatPoints'].includes(item.link)){
        const {status, data} = await getCoupons(0);
        if (status === 200) {
          couponsList = data.records.filter(item => item?.recoveryStatus != 1)
        } else {
          this.$error('查找卡券时出现错误！');
          return
        }
      }
      if(item.link == 'weChatRedPacket'){
        couponsList = couponsList.filter(item => item.couponsCategory.includes("weChatRedPacket"))
        if ( couponsList.length > 0) {
          this.$push({ path: '/points?id=' + couponsList[0].couponsId });
        } else {
          this.$push({ path: '/points' });
        }
        return
      }
      if(item.link == 'weChatPoints'){
        couponsList = couponsList.filter(item => item.couponsCategory.includes("weChatPoints"))
        if (couponsList.length > 0) {
          this.$push({ name: 'RevampWeChatPoints', query: { id: couponsList[0].couponsId } });
        }else{
          this.$error('没有找到可使用该服务的卡券');
        }
        return
      }
      if(item.link == 'recovery'){
        couponsList = couponsList.filter(item => item.couponsCategory.includes("recovery"))
        if (couponsList.length > 0) {
          this.batchHandleNext(couponsList[0].couponsId)
        } else {
          this.$error('没有找到可转让的卡券');
        }
        return
      }
      if(['bankWithdraw','alipayWithdraw'].includes(item.link)){
        couponsList = couponsList.filter(item => item.couponsBuyerId === '992d00548582496db8f8b0426f767deb')
        if (couponsList.length > 0) {
          this.$store.commit('setCoupon', couponsList[0])
          this.$push({ name: "Withdraw", query: { type: item.link } });
        } else {
          this.$error('没有找到可使用该服务的卡券');
        }
        return
      }
      // let mouldId = this.$route.query.couponsMouldId;
      let mouldId = item.couponsMouldId;
      let upstreamId = this.$route.query.couponsUpstreamId;
      let buyerUserId = this.$route.query.couponsBuyerUserId;
      location.href =
        "/onLineIndex" +
        "?ident=" +
        item.link +
        "&name=" +
        item.name +
        "&categoryId=" +
        item.id +
        "&mouldId=" +
        mouldId +
        "&upstreamId=" +
        upstreamId +
        "&buyerUserId=" +
        buyerUserId;
    },
    offlineClickHandle(item) {
      console.error(item)
      // if (item.link === "carWashing") {
      //   this.$push({
      //     path: "/washCar",
      //     query: {
      //       categoryId: item.id,
      //       categoryIdent: item.link,
      //       upstreamId: this.$route.query.couponsUpstreamId,
      //       buyerUserId: this.$route.query.couponsBuyerUserId,
      //       mouldId: this.$route.query.couponsMouldId,
      //     },
      //   });
      // }
      if (
        item.link === "inspect" ||
        item.link === "safeStop" ||
        item.link === "drivingProtect" ||
        item.link === "moveCarService" ||
        item.link === "violationSearch"
      ) {
        this.$push({
          path: "/offLineIndex",
          query: {
            categoryId: item.id,
            categoryIdent: item.link,
            name: item.name,
            upstreamId: this.$route.query.couponsUpstreamId,
            buyerUserId: this.$route.query.couponsBuyerUserId,
            mouldId: this.$route.query.couponsMouldId,
          },
        });
      } else if (item.link === "safeCheck") {
        this.$push({
          path: "/carSatety",
          query: {
            name: "车辆安全检测",
          },
        });
      } else if (item.link === "carOwnercare") {
        this.$dialog({
          title: "提 示",
          message: "系统正在升级维护中...",
        }).then(() => {});
      } else {
        this.$push({
          path: "/washCar",
          query: {
            categoryId: item.id,
            categoryIdent: item.link,
            upstreamId: this.$route.query.couponsUpstreamId,
            buyerUserId: this.$route.query.couponsBuyerUserId,
            mouldId: this.$route.query.couponsMouldId,
          },
        });
      }
    },
    carSatetyHandle() {
      this.$push({
        path: "/carSatety",
        query: {
          name: "车辆安全检测",
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.health_banner {
  background: #00bfbf;
  margin: 25px -20px 0;
  height: 80px;
}
.health_doctor {
  border-radius: 10px;
  background: #fff;
  height: 80px;
  box-shadow: #32323340 0 0 10px;
  margin-bottom: 20px;
  .doct {
    float: left;
    width: 65px;
    padding: 10px;
    border-right: 1px solid #eee;
    height: 60px;
    b {
      display: block;
      font-size: 14px;
    }
    span {
      font-size: 12px;
      color: #999;
      display: block;
    }
  }
  ul {
    padding-left: 86px;
    li {
      display: inline-block;
      width: 33%;
      font-size: 14px;
      text-align: center;
      height: 69px;
      padding-top: 11px;
      img {
        display: block;
        margin: 0 auto;
        // width: 50px;
        height: 40px;
      }
      span {
        display: block;
      }
    }
    li:nth-child(2) {
      border-left: 1px solid #eee;
      border-right: 1px solid #eee;
    }
  }
}
.indexUser {
  // background: linear-gradient(
  //   180deg,
  //   var(--depYelColor) 8%,
  //   var(--bgColor) 220px
  // );
  .userInfo {
    padding: 30px 10px 10px;
    // color: var(--activeColor);
    color: #333333;
    margin: -21px -5px 10px;
    background: #ffffff;
    border-radius: 10px 10px;
    position: relative;
    font-size: var(--smallFont);
    box-shadow: #20733d33 0 0 10px;
    .kimg {
      width: 40px;
      height: 40px;
      min-width: 40px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .name {
      flex: 1;
      z-index: 1;
      font-weight: var(--defaultFontWeight);
      font-size: var(--pFont);
      min-width: 25%;
      span {
        font-weight: normal;
        font-size: 13px;
        word-break: break-all;
      }
    }
  }
  .indexBannar {
    margin: 0 -20px;
  }
  .van-notice-bar {
    padding: 0 10px;
    margin: 0px -5px -5px;
    background: #f4edd6;
    height: 30px;
    border-radius: 50px;
  }
  .warning {
    margin-top: 6px;
  }
  .healthCare {
    margin-top: -13px;
    .listItem {
      height: 70px;
      font-size: var(--pFont);
      color: #ffffff;
      position: relative;
      margin-top: 13px;
      border-radius: 10px;

      box-shadow: #ddd 0 0 20px;
      background: #fff;
      p {
        position: absolute;
        top: 8px;
        left: 8px;
      }
      .iconfont {
        position: absolute;
        bottom: 2px;
        right: 10px;
        font-size: 36px;
        font-weight: normal;
      }
    }
    .little {
      width: 48%;
    }
    .more {
      width: 30%;
    }
    .listItem:last-child:nth-child(3n + 2) {
      margin-right: calc((100% - 30%) / 2);
    }
    .listItem:active::before {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background-color: #666;
      border: inherit;
      border-color: #666;
      border-radius: inherit;
      opacity: 0.1;
      content: "";
    }
  }
  .serviceList {
    overflow: hidden;
    margin: 0 -5px;

    justify-content: left;
    li {
      width: 25%;
      font-size: 12px;
      margin-top: 10px;
      .icons {
        width: 75px;
        height: 50px;
        border-radius: 50%;
        .online-icon {
          width: 75%;
        }
        .offline-icon {
          width: 65%;
        }
        .iconfont {
          font-size: 30px;
          font-weight: bold;
        }
      }
      span {
        display: inline-block;
        margin: 0px 0 10px;
        text-align: center;
      }
    }
  }
}
.platebox h3 {
  color: #fff;
  margin: 20px 0 10px;
  span {
    display: none;
  }
}

.carservicebg {
  // background: #1989fa;
  // position: absolute;
  // height: 85px;
  // left: 0;
  // width: 100%;
  // top: 0px;
  // z-index: -1;
  background: #1989fa;
  height: 85px;
  left: 0;
  margin: 0 -20px;
}
.carService {
  margin-top: 20px;
  border-radius: 0px;
  position: relative;
  .listItem {
    margin: 2px 20px;
    // padding: 20px 0 0 20px;
    background-color: #fff;
    overflow: hidden;
    background-size: 70% auto;
    background-repeat: no-repeat;
    background-position: right center;
    .carDetail {
      padding: 10px 0 10px 20px;

      h3 {
        font-size: 20px;
        color: var(--depBlueColor);
      }
      p {
        margin: 5px 0 3px;
        font-size: var(--pFont);
        color: #333;
      }
      span {
        font-size: var(--spanFont);
        color: #999;
      }
    }
    .examine {
      // justify-content: space-between;
      border-top: 0px solid #f2f2f2;
      background: none;
      padding: 0 10px;
      line-height: 3;
      align-items: center;
      // .van-cell__title {
      //   flex: initial;
      // }
      .van-cell__title {
        .iconfont {
          width: 30px;
          font-size: 22px;
          color: var(--redColor);
          margin-right: 5px;
          vertical-align: middle;
          line-height: 1;
        }
        .left {
          display: flex;
          align-items: center;
          font-size: var(--smallFont);
          color: var(--defaultColor);
          .check {
            margin-right: 5px;
            width: 30px;
            height: 30px;
            // background: var(--depBlueColor);
            // border-radius: 50%;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: var(--defaultFontWeight);
          }
        }
      }
      .van-cell__value {
        // display: flex;
        -webkit-box-flex: none;
        -webkit-flex: none;
        flex: none;
        align-items: center;
        .left {
          display: flex;
          align-items: center;
          font-size: var(--smallFont);
          color: var(--defaultColor);
          .check {
            margin-right: 5px;
            width: 30px;
            height: 30px;
            // background: var(--depBlueColor);
            // border-radius: 50%;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: var(--defaultFontWeight);
          }
        }
      }
      .right {
        button {
          border-radius: 5px;
          height: 24px !important;
        }
      }
    }
  }
  .titile {
    position: relative;
    z-index: 1;
  }
  .carBannar {
    margin: 0 -20px;
    .swipes {
      transform: translateZ(0);
      .listItem {
        margin: 10px 20px;
        padding: 0px 0;
        box-shadow: #32323340 0 0 10px;
        background-color: #fff;
        overflow: hidden;
        .carDetail {
          background-size: 100%;
          background-repeat: no-repeat;
          padding-bottom: 5%;
          h3 {
            font-size: 20px;
            color: #333;
            // color: var(--depBlueColor);
          }
          p {
            margin: 5px 0 3px;
            font-size: var(--pFont);
            color: #333;
          }
          span {
            font-size: var(--spanFont);
            color: #999;
          }
        }
        .footer {
          margin-left: -20px;
          border-top: 1px solid var(--lineColor);
          .left {
            width: 32%;
            padding: 5px;
            border-right: 1px solid var(--lineColor);
            .icon {
              position: relative;
              .iconfont {
                font-size: 30px;
                color: var(--redColor);
                margin-right: 8px;
              }
              span {
                position: absolute;
                top: -2px;
                right: 5px;
                width: 13px;
                height: 13px;
              }
            }
            span {
              font-size: var(--smallFont);
            }
          }
          .right {
            font-size: var(--smallFont);
            padding: 5px 10px 5px 5px;
            flex: 1;
            .text {
              width: 25px;
              height: 25px;
              background: var(--depBlueColor);
              border-radius: 50%;
              color: #fff;
              margin: 0 4px;
            }
            p {
              flex: 1;
              word-break: break-all;
            }
            .van-button--small {
              margin-left: auto;
              height: 24px;
              padding: 0 10px;
              border-radius: var(--defaultRadius);
            }
          }
        }
      }
      .unCurrent {
        opacity: 0.5;
        margin: 10px -10px 10px;
      }
    }
  }
  .address {
    border: 1px solid var(--depBlueColor);
    color: var(--depBlueColor);
    font-size: var(--smallFont);
    background: #fff;
    padding: 6px 8px;
    margin-top: 10px;
    .iconfont {
      margin-right: 8px;
    }
    span {
      margin-left: auto;
    }
    b {
      font-weight: bold;
      margin-right: 2px;
    }
  }
  .more {
    text-align: center;
    color: var(--depBlueColor);
    font-size: var(--smallFont);
    height: 40px;
    line-height: 42px;
    background: #fff;
    margin-top: 5px;
  }

  .serviceList {
    overflow: hidden;
    margin: 0 -5%;
    padding-top: 10px;
    margin-top: -10px;
    li {
      width: 25%;
      font-size: 14px;
      margin: 5px 0 10px;
      .icons {
        width: 75px;
        height: 45px;
        // border-radius: 50%;
        // box-shadow: #ccc 0 0 5px;
        // background: #fff;
        .iconfont {
          font-size: 32px;
          color: var(--depBlueColor);
        }
      }
      span {
        display: inline-block;
        margin-top: 10px;
        text-align: center;
      }
    }
    li:last-child:nth-child(4n + 2) {
      margin-right: calc((100% - 25%) / 3 * 2);
    }
    li:last-child:nth-child(4n + 3) {
      margin-right: calc((100% - 25%) / 3 * 1);
    }
  }
}
.platebox {
  .title {
    padding: 15px 0px 0px 0;
    .name {
      color: #fff;
      font-size: var(--middleFont);
      .iconfont {
        font-size: 0px;
      }
    }
    .editCar {
      color: #fff;
      font-size: 14px;
      opacity: 0.8;
    }
  }
}

.unCurrent {
  opacity: 0.5;
  margin: 2px -10px;
}
.van-cell__title,
.van-cell__value {
  display: initial;
  -webkit-box-flex: none;
  -webkit-flex: none;
  flex: none;
  background: #f2f2f2;
  line-height: 35px;
  margin: 0px 10px 10px 0;
  padding: 0px 10px;
  border-radius: 50px;
}

.popularExchange {
  margin-top: -13px;
  .listItem {
    width: 46%;
    position: relative;
    margin-top: 15px;
    font-size: var(--smallFont);
    span {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 20px;
      height: 20px;
    }
    .goodsImg {
      background: #fff;
      height: 106px;
    }
    h5 {
      font-size: var(--smallFont);
      font-weight: normal;
      color: var(--titleColor);
      height: 34px;
      margin: 10px 0 6px;
      box-sizing: border-box;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      // white-space: nowrap;
    }
    p {
      font-size: var(--titleFont);
      color: var(--redColor);
      i {
        font-style: normal;
        font-size: 12px;
      }
    }
  }
}
.recommend{
  color: white;
  border-width: 0px;
  width: 100%;
  height: 40px;
  background: inherit;
  border-radius: 5px;
  margin: 15px 0;
}
.gift{
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 10px;
  font-size: 12px;
  position: relative;
  span:nth-child(2){
    font-weight: 600;
    margin-left: 10px;
  }
}
.userImg{
  width: clamp(25px, 7vw, 30px);
  height: clamp(25px, 7vw, 30px);
  border-radius: 50%;
  background-color: #D9001B;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lgImg{
  width: clamp(16px, 4vw, 22px);
  height: clamp(16px, 4vw, 22px);
}
.userMobile{
  margin-left: 5px;
  font-size: 9px;
  color: #aaaaaa;
  font-weight: 400;
}
.cardTag{
  padding: 0 7px;
  border-radius: 5px;
  height: 28px; 
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  span:nth-child(2){
    margin-left: 5px;
  }
}
.vipcard {
  background-color: #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0;
  font-size: 12px;
  margin: -13px -10px;
  width: 100%;
  padding: 8px 12px;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  .vip-card {
    border: 1px solid #adadad;
    background: #fff;
    border-radius: 10px;
  }
  .vip-label {
    border-radius: 10px 0 0 10px;
    font-size: 10px;
    background: #d9001b;
    color: #fff;
    padding: 2px 6px;
    font-weight: 500;
  }
  .vip-id {
    color: #adadad;
    font-weight: 700;
    font-size: 10px;
    padding: 0 5px;
  }
  .vip-left {
    display: flex;
    align-items: center;
    gap: 6px;
    .verified-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 2px;
      background: #63a103;
      padding: 0px 6px;
      border-radius: 10px;
      font-size: 10px;
      border: 1px solid #63a103;
      color: #fff;
    }
  }
  .vip-right{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .vip-link {
      margin-left: 5px;
      font-size: 10px;
      color: #aaaaaa;
    }
  }
}
.flex{
  display: flex;
}
@media screen and (min-width: 390px){
  .vipbody{
    display: flex;
    justify-content: space-between
  }
}
.online-div{
  width: clamp(40px, 20vw, 65px);
  height: clamp(40px, 20vw, 65px);
  border-radius: 50%;
  box-shadow: 0px 0px 2px 1px #e6e6e6;
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .online-mask{
    position: absolute;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    background: #ffffff5c;
  }
}
.pageSpanFont{
  color: #aaaaaa;
}
.bubble{
  padding: 2px 5px;
  height:15px; 
  position: absolute;
  top: -10px;
  right: 0;
  border-radius: 10px;
  background-color: #f2f2f2;
  color: #9e9e9e;
}
</style>
